import { useApolloClient } from "@apollo/client";
import Cookies from "js-cookie";
import { useCallback } from "react";
import { useAuthStore } from "./useAuth";

export function useLogout() {
  const client = useApolloClient();
  const setAuthenticated = useAuthStore.use.setAuthenticated();

  return useCallback(() => {
    client.clearStore();
    setAuthenticated(false);
    Cookies.remove("session_token");
    localStorage.removeItem("auth_token");
  }, [client, setAuthenticated]);
}
